/* Jungle: phone shopping helpers (Website & SEO, 2 Nov 2026).
   Found in the 1 Nov phone test:
   1. Add to kit bag gave almost no sign on a phone (only a tiny "1" on the bag icon).
      -> after a successful add, show "Added to your kit bag" with Checkout / View kit bag.
   2. On the phone cart page the Checkout button sat just below the screen.
      -> while the real button is off screen, keep a Checkout bar stuck to the bottom.
   Phones only (under 750px). Desktop is untouched. */
(function () {
  'use strict';

  var PHONE = window.matchMedia('(max-width: 749px)');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(pence, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
        { style: 'currency', currency: currency || 'GBP' }).format(pence / 100);
    } catch (e) { return '£' + (pence / 100).toFixed(2); }
  }

  var css = document.createElement('style');
  css.textContent =
    '.jkb{position:fixed;left:0;right:0;bottom:0;z-index:1000;background:#2f3a24;color:#fff;' +
    'padding:14px max(16px,env(safe-area-inset-left,0px)) calc(14px + env(safe-area-inset-bottom,0px));' +
    'box-shadow:0 -4px 16px rgba(0,0,0,.25);font-family:inherit;transform:translateY(110%);transition:transform .25s ease}' +
    '.jkb.is-open{transform:none}' +
    '.jkb__row{display:flex;align-items:center;gap:10px}' +
    '.jkb__msg{flex:1;min-width:0;font-weight:600;font-size:15px;line-height:1.3}' +
    '.jkb__msg small{display:block;font-weight:400;opacity:.85;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.jkb__close{background:none;border:0;color:#fff;font-size:22px;line-height:1;padding:4px 6px;cursor:pointer}' +
    '.jkb__btns{display:flex;gap:10px;margin-top:12px}' +
    '.jkb__btns a{flex:1;text-align:center;padding:12px 8px;border-radius:2px;font-weight:600;text-decoration:none;font-size:15px}' +
    '.jkb__go{background:#e2b23a;color:#1f241c}' +
    '.jkb__view{border:1px solid rgba(255,255,255,.7);color:#fff}' +
    '.jcb{position:fixed;left:0;right:0;bottom:0;z-index:999;background:#fff;border-top:1px solid #ddd;' +
    'padding:10px max(16px,env(safe-area-inset-left,0px)) calc(10px + env(safe-area-inset-bottom,0px));' +
    'display:flex;align-items:center;gap:12px;box-shadow:0 -4px 12px rgba(0,0,0,.08)}' +
    '.jcb[hidden]{display:none}' +
    '.jcb__total{font-weight:600;white-space:nowrap}' +
    '.jcb__go{flex:1;text-align:center;background:#e2b23a;color:#1f241c;border:0;border-radius:2px;padding:13px 8px;font-weight:600;font-size:15px;cursor:pointer}' +
    '@media (prefers-reduced-motion: reduce){.jkb{transition:none}}';
  document.head.appendChild(css);

  /* 1. Added-to-kit-bag message */
  var bar, timer;
  function showAdded(title) {
    if (!PHONE.matches) return;
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'jkb';
      bar.setAttribute('role', 'status');
      bar.setAttribute('aria-live', 'polite');
      bar.innerHTML =
        '<div class="jkb__row"><div class="jkb__msg">Added to your kit bag ✓<small></small></div>' +
        '<button type="button" class="jkb__close" aria-label="Close">×</button></div>' +
        '<div class="jkb__btns"><a class="jkb__view" href="' + root + 'cart">View kit bag</a>' +
        '<a class="jkb__go" href="' + root + 'checkout">Checkout</a></div>';
      bar.querySelector('.jkb__close').addEventListener('click', hide);
      document.body.appendChild(bar);
    }
    bar.querySelector('small').textContent = title || '';
    requestAnimationFrame(function () { bar.classList.add('is-open'); });
    clearTimeout(timer);
    timer = setTimeout(hide, 8000);
  }
  function hide() { if (bar) bar.classList.remove('is-open'); }

  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    if (d.source !== 'product-form-component' || d.didError) return;
    var h1 = document.querySelector('h1');
    showAdded(h1 ? h1.textContent.trim() : '');
  });

  /* 2. Checkout bar on the phone cart page */
  function cartBar() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    var real = document.querySelector('.cart__checkout-button');
    if (!real) return;
    var sticky = document.createElement('div');
    sticky.className = 'jcb';
    sticky.hidden = true;
    sticky.innerHTML = '<span class="jcb__total"></span><button type="button" class="jcb__go">Checkout</button>';
    sticky.querySelector('.jcb__go').addEventListener('click', function () { real.click(); });
    document.body.appendChild(sticky);

    var onScreen = true;
    function update() {
      sticky.hidden = onScreen || !PHONE.matches || !sticky.querySelector('.jcb__total').textContent;
    }
    function refreshTotal() {
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        sticky.querySelector('.jcb__total').textContent = c.item_count ? money(c.total_price, c.currency) : '';
        check();
      }).catch(function () {});
    }
    refreshTotal();
    document.addEventListener('cart:update', refreshTotal);

    function check() {
      var r = real.getBoundingClientRect();
      onScreen = r.bottom > 0 && r.top < window.innerHeight - 8;
      update();
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    PHONE.addEventListener('change', check);
    window.addEventListener('load', check);
    /* other scripts (e.g. the free-delivery bar) push the button down after load */
    if ('ResizeObserver' in window) new ResizeObserver(check).observe(document.body);
    setTimeout(check, 1500);
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cartBar);
  else cartBar();
})();
